import { withRouter, Link } from "react-router-dom"
import React, { useEffect, useState } from "react"
import { Card, Button, CardBody, Row, Col } from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { changeLocationStatus } from "helpers/repository"
function Table(props) {
  const [isOpen, setIsOpen] = useState(false)

  const setLocationsStatus = id => {
    changeLocationStatus(id, successSetLocation, errorSetLocation)
  }

  const successSetLocation = res => {
    props.getLocations()
  }

  const errorSetLocation = err => {
    console.log("error")
  }

  const { data } = props
  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
      formatter: (cellContent, row) => <>{row.bb_id}</>,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "sport",
      text: "Sport Name",
      sort: true,
      formatter: (cellContent, row) => <>{row?.sport?.name}</>,
    },
    {
      dataField: "view",
      isDummyField: true,
      text: "Action",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <>
          <Row>
            <Col lg={5}>
              <Button
                onClick={() => {
                  setLocationsStatus(row.id)
                }}
                type="button"
                color="primary"
                className="btn-sm"
              >
                {row.status == 0 ? "Activate" : "Deactivate"}
              </Button>
            </Col>
          </Row>
        </>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]
  const { SearchBar } = Search

  const pageOptions = {
    sizePerPage: 20,
    totalSize: props.count,
    custom: true,
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setIsOpen(true)
    },
  }
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Locations"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="6">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}></Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            //   selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                            rowEvents={rowEvents}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  )
}

export default Table
